import React, { useState } from 'react';
import { branding } from '@config/branding';

interface LogoProps {
  className?: string;
  alt?: string;
}

const Logo: React.FC<LogoProps> = ({
  className,
  alt = `${branding.appTitle} Logo`,
}) => {
  const [hasError, setHasError] = useState(false);
  //fallback to text-based logo if image fails to load or if iconUrl is not provided
  if (!branding.iconUrl || hasError) {
    return (
      <div
        className={className}
        role="img"
        aria-label={alt}
        title={alt}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f0f0f0',
          color: '#666',
          fontSize: '0.75rem',
          fontWeight: 500,
        }}
      >
        {branding.appTitle}
      </div>
    );
  }

  return (
    <img
      src={branding.iconUrl}
      alt={alt}
      className={className}
      onError={() => setHasError(true)}
    />
  );
};

export default Logo;
